<template>
    <div>
         <v-snackbar v-model="snackbar" :top=true :color="color" :timeout=6000>
      <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
       <v-col cols="12" sm="12">
        <v-card class="box">
            <v-col cols="12" sm="12">
                <v-toolbar class="toolbar" flat dense>
                    <v-toolbar-title>
                        <strong>
                            Offer Grading Scheme
                        </strong>
                    </v-toolbar-title>
                </v-toolbar>
                <v-row align="center" justify="center">
                    <v-col cols="12" sm="4" md="4" class="pt-6 m-0">
                        <v-autocomplete dense required outlined rounded color="#0F2027" v-model="grading_scheme" :items="grading_scheme_list" item-text="name" item-value="id" label="Grading Scheme" persistent-hint hint="Please select grading scheme" />
                    </v-col>
                    <v-col cols="12" sm="4" md="4" class="pt-6 m-0">
                        <v-autocomplete dense required outlined rounded color="#0F2027" v-model="ay" :items="ay_list" item-text="ay" item-value="id" label="Academic Year" persistent-hint hint="Please select academic year" />
                    </v-col>
                </v-row>
                <v-row align="center" justify="center">
                    <v-btn dense outlined rounded class="button" @click="offerGradingScheme()">Offer</v-btn>
                </v-row>
                <v-row class="p-0 m-0" v-if="grading_offer_list.length > 0">
                  <v-col class="p-0 m-0" cols="12" sm="6" md="6"> </v-col>
                  <v-col class="p-0 m-0" cols="12" sm="6" md="6">
                      <v-text-field class="search" v-model="search" append-icon="mdi-magnify" label="Search in table" single-line hide-details></v-text-field>
                  </v-col>
                </v-row>
                <v-data-table v-if="grading_offer_list.length > 0" dense :headers="headers" :items="grading_offer_list" :search="search" class="elevation-1 mytable">
                  <template v-slot:item.options="{ item }">
                            <v-row>
                           <v-switch v-model="item.isactive" class="p-0" color="#0F2027" @change="isactive(item.id)"></v-switch>
                            </v-row>
                        </template>   
                </v-data-table>
            </v-col>
        </v-card>
       </v-col>
    </div>
</template>
<script>
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    import axios from "axios";
    export default {
        data() {
            return {
                snackbar_msg: null,
                snackbar: false,
                color: "",
                ay_list: [],
                ay: null,
                grading_scheme_list: [],
                grading_scheme: null,
                grading_offer_list:[],
                search:null,
                headers: [
                    {
                        text: "Sr. No.",
                        sortable: false,
                        value: "srno",
                    },
                    {
                        text: "Grading Scheme",
                        align: "left",
                        sortable: false,
                        value: "gradingscheme",
                    }, 
                     {
                        text: "Academic Year",
                        align: "left",
                        sortable: false,
                        value: "academicyear",
                    },
                    {
                        text: "Isactive",
                        align: "left",
                        sortable: false,
                        value: "options",
                    },
                ]
            };
        },
        methods: {
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            isactive(item){
              const formData = {
                    grading_offer_scheme:item,
                };
                axios
                    .post("/examination/isactiveGradingScheme", formData)
                    .then((res) => {
                         if (res.data.status == "YES") {
                            this.showSnackbar("#4caf50", "Offer Grading Scheme Updated Successfully");
                            this.onload()
                        }
                    })
                    .catch((error) => {
                        alert("Somthing went wrong!!!");
                    })
                    .finally(() => {
                        //stop loader
                    });
            },
              offerGradingScheme() {
                if(this.grading_scheme == null){
                  this.showSnackbar("#b71c1c", "Please select Grading Scheme!!...");
                  return
                }
                 if(this.ay == null){
                  this.showSnackbar("#b71c1c", "Please select Academic Year!!...");
                  return
                }
                const formData = {
                    grading_scheme:this.grading_scheme,
                    ay:this.ay,
                };
                console.log(formData);
                axios
                    .post("/examination/offergradingscheme", formData)
                    .then((res) => {
                         if (res.data.status == "YES") {
                           if (res.data.flag == "NEW") {
                              this.showSnackbar("#4caf50", "Grading Scheme Offered  Successfully");
                              this.onload()
                           }
                           else if(res.data.flag == "Exist") {
                              this.showSnackbar("#b71c1c", "Grading Scheme  Already Offered!!...");
                              this.onload()
                           }
                        }
                    })
                    .catch((error) => {
                        alert("Somthing went wrong!!!");
                    })
                    .finally(() => {
                        this.grading_scheme = null
                        this.ay = null
                    });
            },
            onload(){
              axios
                .post("/examination/offerGradingScheme")
                .then((res) => {
                    this.grading_scheme_list = res.data.grading_scheme_list;
                    this.ay_list = res.data.ay_list;
                    this.grading_offer_list = res.data.grading_offer_list;
                })
                .catch((error) => {
                    alert("Somthing went wrong!!!");
                })
                .finally(() => {
                    //stop loader
                });
            }
        },
        mounted() {
            this.onload()
        },
    };
</script>